import { render } from "./testView.vue?vue&type=template&id=b6b29cc8&scoped=true"
const script = {}

import "./testView.vue?vue&type=style&index=0&id=b6b29cc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6b29cc8"]])

export default __exports__